import { ObjectPrivilege } from "@/types/enums";

export const MAX_EMAILS = 20;
export const DEFAULT_PRIVILEGE = ObjectPrivilege.Read